import getStarted1 from '../../../assets/images/get_started_1.png';
import getStarted2 from '../../../assets/images/get_started_2.png';
import getStarted3 from '../../../assets/images/get_started_3.png';
import { COURT_NAME } from '../../../lib/constants/globalConstant';

//FOR DEMO CHANGED SELECT YOUR TOKENS 

// Pick your token => Select you tokens
// your team's digital field => the digital replica of Alamadome

const getStartedData = [
    {
        id: 1,
        heading: "Create Your Account",
        description: "Join the digital fan community and start supporting the team.",
        image: getStarted1,
    },
    {
        id: 2,
        heading: "Purchase Your Space in Digital Field",
        description: `Choose your favorite zones and claim your place inside the digital replica of sports field.`,
        image: getStarted2,
    },
    {
        id: 3,
        heading: "Participate All Season",
        description: "Watch your zones come alive on game day while earning points, status, and exclusive fan experiences.",
        image: getStarted3,
    },
]

export default getStartedData